/* eslint-disable no-param-reassign */
export default {
  namespaced: true,
  state: {
    auth: {},
  },
  getters: {
    get: (state) => state.auth,
  },
  mutations: {
    set(state, payload) {
      state.auth = payload
    },
  },
  actions: {
    set({ commit }, payload) {
      commit('set', payload)
    },
  },
}
